import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { CampaignId, CampaignParametersApiInterface } from 'modules/campaigns/types/campaign-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { useControlledSwr } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseGetCampaignParametersInterface {
  campaignId: CampaignId;
}
export function useGetCampaignParameters(t0) {
  const $ = _c(8);
  const {
    campaignId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== campaignId) {
    t2 = () => [`${CAMPAIGNS_API}/${campaignId}`, RequestModuleEnum.Campaign];
    $[1] = campaignId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== fetcher) {
    t3 = url => fetcher(url);
    $[3] = fetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: campaignParameters,
    mutate: mutateCampaignParameters
  } = useControlledSwr(t2, t3, undefined, !!user);
  let t4;
  if ($[5] !== campaignParameters || $[6] !== mutateCampaignParameters) {
    t4 = {
      campaignParameters,
      mutateCampaignParameters
    };
    $[5] = campaignParameters;
    $[6] = mutateCampaignParameters;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}